import { Link } from 'react-router-dom';
import { Header } from '@/components/layout/Header';

export function TermsPage() {
  return (
    <div className="min-h-full bg-gray-50">
      <Header />
      <div className="max-w-3xl mx-auto p-6 bg-white">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Điều khoản sử dụng</h1>
        <p className="text-sm text-gray-500 mb-6">Cập nhật: 06/2026</p>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">1. Chấp nhận điều khoản</h2>
            <p>
              Bằng việc sử dụng MyMap, bạn đồng ý tuân thủ các điều khoản này. Nếu không đồng ý,
              vui lòng không sử dụng dịch vụ.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">2. Tính chất dữ liệu</h2>
            <p className="font-semibold text-amber-700 bg-amber-50 p-3 rounded border border-amber-200">
              ⚠️ Dữ liệu trên MyMap mang tính chất THAM KHẢO, không có giá trị pháp lý.
            </p>
            <p>
              Mọi thông tin quy hoạch, thửa đất, giá giao dịch chỉ phục vụ mục đích tham khảo.
              Để có giá trị pháp lý, vui lòng liên hệ cơ quan nhà nước có thẩm quyền.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">3. Tài khoản người dùng</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Bạn chịu trách nhiệm bảo mật mật khẩu của mình</li>
              <li>Không chia sẻ tài khoản cho người khác</li>
              <li>Thông báo ngay nếu phát hiện truy cập trái phép</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">4. Thanh toán</h2>
            <p>
              Mọi giao dịch thanh toán qua cổng SePay đều không hoàn lại. Gói tháng có hiệu lực
              30 ngày kể từ ngày kích hoạt. Hết hạn sẽ tự động chuyển về chế độ Guest.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">5. Giới hạn trách nhiệm</h2>
            <p>
              MyMap không chịu trách nhiệm về bất kỳ thiệt hại nào phát sinh từ việc sử dụng
              thông tin trên nền tảng này, bao gồm nhưng không giới hạn: quyết định đầu tư, mua bán
              bất động sản, xây dựng.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">6. Liên hệ</h2>
            <p>Mọi thắc mắc xin liên hệ UBND xã hoặc email: <a href="mailto:support@mymap.vn" className="text-brand-600">support@mymap.vn</a></p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link to="/" className="text-brand-600 hover:underline">← Về trang chủ</Link>
        </div>
      </div>
    </div>
  );
}
